// Handles Vite's `vite:preloadError`, which fires when a dynamically imported
// chunk fails to load. The common cause is a deploy: a tab still running the
// previous build requests a hashed chunk filename that no longer exists on the
// server, so the next lazy route navigation 404s. A reload picks up the fresh
// asset manifest and recovers transparently.

const RELOAD_TIMESTAMP_KEY = 'studio:preload-error-reload-at';
const RELOAD_COOLDOWN_MS = 10_000;

export function registerPreloadErrorReload(): () => void {
  const handler = (event: Event) => {
    const lastReloadAt = Number(sessionStorage.getItem(RELOAD_TIMESTAMP_KEY) ?? 0);
    const now = Date.now();

    // We already reloaded for a preload error moments ago and still hit one, so
    // a stale deploy isn't the cause (e.g. the asset is genuinely missing). Let
    // the error propagate to the ErrorBoundary and Sentry instead of looping.
    if (lastReloadAt && now - lastReloadAt < RELOAD_COOLDOWN_MS) {
      return;
    }

    // Suppress Vite's default rethrow and reload to pick up the new manifest.
    event.preventDefault();
    sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, String(now));
    window.location.reload();
  };

  window.addEventListener('vite:preloadError', handler);
  return () => window.removeEventListener('vite:preloadError', handler);
}
